import {
  Box,
  GridItem,
  Grid,
  Text,
  Divider,
  Flex,
  Spinner,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { RightArrow } from "../assets/svgs/Icons";
import {
  getIncomingTCs,
  getOutgoingTCs,
} from "../Pages/TransactionCertificate/TransactionCertificateSlice";
import { useDispatch, useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";

export const IncomingTcCard = () => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState("idle");
  const [tcData, setTcData] = useState([]);
  const [isStateLoading, setIsSatateLoading] = useState(true);
  const { incomingTCs, isLoading } = useSelector(
    (state) => state.transactionCertificateClient
  );
  const { userData } = useSelector((state) => state.auth);
  let companyId = userData?.companyId;

  const getList = async () => {
    if (companyId) {
      try {
        setStatus("pending");
        const resultAction = await dispatch(getIncomingTCs(companyId));
        const result = unwrapResult(resultAction);
        setTcData(result);
        setIsSatateLoading(false);
        setStatus("success");
      } catch (error) {
        setStatus("failed");
        console.error(error);
      }
    }
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <>
      <Box margin={"1rem"}>
        <Flex flexDirection={"column"}>
          <Box margin={"0.5rem"}>
            <Flex justifyContent={"space-between"}>
              <Text fontSize={"19px"} fontWeight={"800"} color={"brand.blue"}>
                Incoming TCs
              </Text>
              {/* <Text
                  fontSize={"13px"}
                  fontWeight={"300"}
                  color={"#2272D5"}
                  paddingTop={"5px"}
                  textDecoration={"underline"}
                >
                  <Link to={"/"}>View All</Link>
                  <RightArrow />
                </Text> */}
            </Flex>
          </Box>
          <Box
            display={"block"}
            bg={"brand.white"}
            p={"1rem"}
            w={"400px"}
            boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
            h={"469px"}
            borderRadius={"15px"}
            overflowY="scroll"
            css={{
              "&::-webkit-scrollbar": {
                width: "7px",
                height: "225px",
              },
              "&::-webkit-scrollbar-track": {
                width: "7px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#B8DEF8",
                borderRadius: "5px",
              },
            }}
          >
            <Box margin={"0.3rem"}>
              {/* Render the incoming TC data from tcData state */}
              {isStateLoading ? (
                <Box alignItems="center" justifyContent="center" height="100vh">
                  <Spinner size="lg" color="brand.blue" />
                  <Text
                    fontSize={"20px"}
                    fontWeight={"800"}
                    textAlign={"center"}
                    mt="1rem"
                  >
                    Loading all incoming TCs...
                  </Text>
                </Box>
              ) : tcData && tcData.length > 0 ? (
                tcData?.map((tc) => (
                  <Box>
                    <Grid
                      key={tc?._id}
                      templateColumns="repeat(6, 1fr)"
                      marginTop={"2rem"}
                      marginBottom={"1rem"}
                      gap={"2rem"}
                    >
                      <GridItem colSpan={4}>
                        <Text
                          fontSize={"18px"}
                          fontWeight={"500"}
                          color={"brand.blue"}
                          mr={2}
                        >
                          {tc?.tc_seller?.name}
                        </Text>
                        <Text
                          fontSize={"14px"}
                          fontWeight={"500"}
                          color={"brand.sage"}
                          mr={2}
                        >
                          {tc?.tc_seller?.address?.city},{" "}
                          {tc?.tc_seller?.address?.state}
                        </Text>
                      </GridItem>
                      <GridItem colSpan={2}>
                        <Text
                          fontSize={"13px"}
                          fontWeight={"300"}
                          color={"#2272D5"}
                          paddingTop={"5px"}
                          textDecoration={"underline"}
                        >
                          <Link to={"/client/transaction-certificates"}>
                            View All
                          </Link>
                          <RightArrow />
                        </Text>
                      </GridItem>
                    </Grid>
                  </Box>
                ))
              ) : (
                <Text
                  textAlign={"center"}
                  fontSize={"18px"}
                  fontWeight={"500"}
                  color={"brand.blue"}
                  mt="1rem"
                >
                  No incoming TCs for this user
                </Text>
              )}
            </Box>
          </Box>
        </Flex>
      </Box>
    </>
  );
};
